import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-scroll'
import throttle from 'lodash.throttle'
import { space, colors, fontSizes } from 'theme'
import { Box, Flex, Grid } from './Layout'
import { Text } from './Typography'

const StyledLink = styled(Link)`
  margin-bottom: ${space.m};
  font-size: ${fontSizes.l};
  color: ${colors.secondaryText};
  cursor: pointer;
  user-select: none;
  transition: color 0.7s cubic-bezier(0.19, 1, 0.22, 1);
  &.active {
    color: ${colors.primaryText};
  }
  &:hover {
    color: initial;
  }
`

const BodyText = styled(Text)`
  opacity: 0.8;
  line-height: 20px;
  letter-spacing: 0.6px;
`

const THRESHOLD_BOTTOM = 1450
const THRESHOLD_TOP = 250

const BlockOfTextWithTableOfContents = ({ content }) => {
  const [contentsMarginTop, setContentsMarginTop] = useState(0)
  const trackScrolling = () => {
    const fromBottom = document.documentElement.scrollHeight - window.pageYOffset
    const fromTop = window.pageYOffset
    if (fromBottom < THRESHOLD_BOTTOM) {
      setContentsMarginTop(fromBottom - THRESHOLD_BOTTOM)
    }
    if (fromTop < THRESHOLD_TOP) {
      setContentsMarginTop(0)
    }
  }
  useEffect(() => {
    document.addEventListener('scroll', throttle(trackScrolling, 50))
  }, [])
  return (
    <Grid gridTemplateColumns={['1fr', 'repeat(2, auto)']} gridGap="xl">
      <Box width="300px">
        <Flex width="inherit" flexDirection="column" position="fixed" display={['none', 'flex']} mt={contentsMarginTop}>
          {content.map(({ name, title }) => (
            <StyledLink key={name} to={name} spy smooth offset={-60} delay={0} duration={200}>
              {title}
            </StyledLink>
          ))}
        </Flex>
      </Box>
      <Flex flexDirection="column">
        {content.map(({ title, name, body }, index) => {
          const isFirst = index === 0
          return (
            <React.Fragment key={name}>
              {!isFirst && (
                <Text fontSize="l" mb="l" fontWeight="bold">
                  {title.toUpperCase()}
                </Text>
              )}
              <BodyText name={name} fontSize="m" mb="l" dangerouslySetInnerHTML={{ __html: body }} />
            </React.Fragment>
          )
        })}
      </Flex>
    </Grid>
  )
}

BlockOfTextWithTableOfContents.propTypes = {
  content: PropTypes.array.isRequired,
}

export default BlockOfTextWithTableOfContents
